import { defineStore } from 'pinia'
import { ref } from 'vue'
import { deepMerge } from 'ts-deep-utils'
import type { components } from '../types/_api'

type UserSettingsData = components['schemas']['User-Settings']['settings']

export const useUserSettingsStore = defineStore('userSettings', () => {
  const uncommittedSettings = ref(new Map<string, Partial<UserSettingsData>>())
  const pendingSettings = ref(new Map<string, Partial<UserSettingsData>>())

  const getUserUncommittedSettings = (userId: string): Partial<UserSettingsData> | undefined => {
    const stored = uncommittedSettings.value.get(userId)
    if (Object.keys(stored ?? {}).length === 0) return
    else return stored
  }

  const hasUserUncommittedSettings = (userId: string): boolean =>
    uncommittedSettings.value.has(userId) && Object.keys(uncommittedSettings.value.get(userId) ?? {}).length > 0

  const mergeUserUncommittedSettings = (userId: string, patch: Partial<UserSettingsData>) => {
    const existing = uncommittedSettings.value.get(userId) ?? {}
    uncommittedSettings.value.set(userId, deepMerge(existing, patch))
  }

  const restorePendingUserSettings = (userId: string, patch: Partial<UserSettingsData>) => {
    const existing = uncommittedSettings.value.get(userId) ?? {}
    uncommittedSettings.value.set(userId, deepMerge(patch, existing))
  }

  const clearUserUncommittedSettings = (userId: string) => {
    uncommittedSettings.value.delete(userId)
  }

  return {
    uncommittedSettings,
    getUserUncommittedSettings,
    hasUserUncommittedSettings,
    mergeUserUncommittedSettings,
    restorePendingUserSettings,
    clearUserUncommittedSettings,

    pendingSettings,
  }
})
